import { Tabs, Divider, message, Spin } from 'antd';
import constants from '../../constants/constants';
import { MessageOutlined } from '@ant-design/icons';
import ChatBotJob from './ChatBotJob';
import ChatBotCareer from './ChatBotCareer';
import { useState,useEffect, useContext } from 'react';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import { CommonContext } from '../../Context';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';

const { TabPane } = Tabs;

const ChatBot = () => {

  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const [activeTab, setActiveTab] = useState('1');
  const [jobExists,setJobExists]=useState(false);
  const [countrycode,setCountryCode]=useState("");
  const [loading,setLoading]=useState(false);

  useEffect(()=>{
    doesChatbotexists();
    trackPageAccess(buyerId,window.location.href)

    // return () => {
    //   window.location.reload();
    // };
  },[])

  //Function to check if chat bot exists
	const doesChatbotexists = async () => {
		setLoading(true);
		const response = await APIUtils.apiCall("GET", WebLinks.GetChatBotExists +buyerId );
		if (response.isCatch) {
			message.error(constants.ERROR_MESSAGE);
		} else {
			if (response.resultObj?.statusCode === "2000") {
				setJobExists(response.resultObj.buyerContainsJobs);
        setCountryCode(response.resultObj.countryCode||"GB");
			} else {
				setJobExists(false);
        setCountryCode("GB");
				message.success(response.resultObj?.message | constants.ERROR_MESSAGE)
			}
		}
		setLoading(false);
	};
	//Render
	return (
    <Spin spinning={loading}>
		<div>
      <div className='uppercase font-bold text-xl'>Chat Bots</div>
			<Divider className='my-3'/>
			<Tabs defaultActiveKey="1" onChange={(e)=>setActiveTab(e)}>
        {loading===true?null:
        <>
            <TabPane
              tab={ <span className='uppercase'><MessageOutlined className='text-xl' />{constants.ChatBotTab1}</span> }
              key={1}
            >
            {activeTab === '1' && (
              <ChatBotJob jobExists={jobExists} countrycode={countrycode}/>
            )}
            </TabPane>
            <TabPane
              tab={ <span className='uppercase'><MessageOutlined className='text-xl' />{constants.ChatBotTab2}</span> }
              key={2}
            >
            {activeTab === '2' && (
              <ChatBotCareer jobExists={jobExists} countrycode={countrycode}/>
            )}
            </TabPane>
          </>
        }
			</Tabs>
		</div>
    </Spin>
	);
};

export default ChatBot;